import { render, staticRenderFns } from "./modalNovidades.vue?vue&type=template&id=044864dd&"
import script from "./modalNovidades.vue?vue&type=script&lang=js&"
export * from "./modalNovidades.vue?vue&type=script&lang=js&"
import style0 from "./modalNovidades.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "modalNovidades.vue"
export default component.exports